<template>
<div class="body">
    <!-- <div class='bg-text'>0 0 7</div> -->
    <div class="login">
        <form class="loginInfo">
            <div>
                <img src="../assets/logo_rectangle.png" style="width:300px;" />
            </div>
            <div class="email">
                <el-input class="login-input" v-model="where.email" @keyup.enter.native="onSubmit" autofocus placeholder="Email"/>
            </div>
            <div class="pwd">
                <el-input class="login-input" type="password" @keyup.enter.native="onSubmit" v-model="where.password" placeholder="Password"/>
            </div>
            <div class="btn">
                <el-button @click="onSubmit" class="loginBtn" round>LOGIN</el-button>
            </div>
            <div class="login-lan">
                <div>————The shortest answer is doing the thing.</div>
            </div>
        </form>
        <div class="login-img">
            <img src="../assets/logo_login_background.jpeg" style="height:100%;" />
        </div>
    </div>
</div>
</template>

<script>
export default {
	data() {
		return {
			where: {
				email: '',
				password: ''
			}
		}
	},
	methods: {
		async onSubmit() {
			const result = await this.$post('user/login',this.where);
			this.$utils.setCookies(result,7);
			if(this.$cache.to_path != null && this.$cache.to_path.name != 'login') {
				this.$router.push({ path: this.$cache.to_path.path ,query: this.$cache.to_path.query});
			} else {
				this.$router.push({ path: 'advList' });
			}
		}
	}
}
</script>

<style>
.login-input > input {
    border: none;
    border-bottom: 1px solid #000;
    border-radius: unset;
}
.login-input > input:-webkit-autofill{
box-shadow: 0 0 0px 1000px #fff inset;
}
.login-input > input:focus {   
	border:none;
}
</style>

<style scoped>
.body {
    display: flex;
    width: 100%;
    align-items: center;
}
.login {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
}
.loginInfo {
    display: flex;
    width: 50%;
    height: 90%;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.login-img {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: right;
    align-items: center;
    overflow: hidden;
    /* background: url(../assets/logo_login_background.jpg) round; */
}
.login-lan {
    align-self: flex-end;
    font-size: 10px;
}
.loginInfo > div {
    margin-bottom: 20px;
}
.email,
.pwd {
    display: flex;
    width: 365px;
    padding-bottom: 20px;
}
.btn {
    width: 400px;
    /* text-align: right; */
}
.loginBtn {
    height: 35px;
    background-color: #020202;
    width: 180px;
    color: #fff;
    box-shadow: 4px 5px 10px #7e7e7e;
}
.footer {
    width: 100%;
    height: 40px;
    background-color: #f2f2f2;
    margin-top: 80px;
    text-align: center;
    font-size: 12px;
    line-height: 40px;
    border-radius: 10px;
}
.bg-text{
    width: 100%;
    height: 100%;
    color:#ffffff;
    font-size:600px;
    text-align: center;
}
.bg-img{
    width: 50%;
    margin-right: 20%;
}
</style>